import React from 'react';

// helpers
import { styled } from 'styled-components';
import { colorsTheme } from 'resources/theme/styled/colors';
import { useEntityIntakeFormContext } from '../../EntityIntakeFormContext';

// components
import { IconButton, IconSVG } from '@ui';
import { ReactComponent as EditIcon } from 'resources/icons/remix-icons/edit-line.svg';

interface IProps {
  navigateToStepKey: string;
}

const SectionTitleNavigateButton = ({ navigateToStepKey }: IProps) => {
  const { selectStep } = useEntityIntakeFormContext();

  return (
    <StyledIconButton
      onClick={() => selectStep(navigateToStepKey)}
      type="ghost"
      icon={
        <StyledIconSVG component={EditIcon} color={colorsTheme.colorWhite} />
      }
    />
  );
};

const StyledIconButton = styled(IconButton)`
  margin-left: ${({ theme }) => theme.marginXs};
`;

const StyledIconSVG = styled(IconSVG)`
  cursor: pointer;
`;

export default SectionTitleNavigateButton;
